var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectDate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 9.16668V15.3333C3.33301 16.0697 3.92996 16.6667 4.66634 16.6667H15.333C16.0694 16.6667 16.6663 16.0697 16.6663 15.3333V9.16668M3.33301 9.16668V6.00001C3.33301 5.26363 3.92996 4.66668 4.66634 4.66668H15.333C16.0694 4.66668 16.6663 5.26363 16.6663 6.00001V9.16668M3.33301 9.16668H16.6663M7.33301 3.33334V6.00001M12.6663 3.33334V6.00001M13.9997 12.6667H7.99967",
    stroke: "#363A44",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectDate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/select_date.78c52cb6fa6a3c7288075667ed3369a0.svg";